import get from "lodash/get";
import { getMatchDisplayValue } from "PFCore/helpers/match_value";
import { getProfileName } from "PFCore/helpers/profile";
import { TableColumn } from "PFTypes";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { RoleWatcher, WatcherProfile, WatcherQuestion } from "../../../../../../types/watchers";

export const useFormatColumnValue = () => {
  const { t } = useTranslation("activities");
  return useCallback((watcher: RoleWatcher, column: TableColumn) => {
    const attributeOrValue = get(watcher, [...(column.attribute || [column.name])]);

    if (column.type === "score") {
      return getMatchDisplayValue(attributeOrValue?.[column.name], {
        showPercentage: true,
        defaultValue: "-"
      });
    }

    if (column.name === "name") {
      return getProfileName(attributeOrValue as WatcherProfile);
    }

    if (column.name === "questions") {
      return ((attributeOrValue as WatcherQuestion[]) || [])
        .map(([question, answer]) => `${question} ${t(`show.interested.table.answers.${answer}`)}`)
        .join(" ");
    }

    return attributeOrValue;
  }, []);
};

export default useFormatColumnValue;
